<template>
  <modal
    :appendToBody="true"
    :top="'12vh'"
    :title="$t(title)"
    :visible.sync="isShowDialog"
  >
    <!-- 基本信息 -->
    <ul class="base-info" v-if="baseMsg.length">
      <li v-for="(item, index) in baseMsg" :key="index">
        <span class="label">{{ $t(item.text) }}：</span>
        <span class="value">
          <template v-if="item.key === 'url'">
            <span>{{ cmdObj.fullPath || cmdObj.scope }}</span>
          </template>
          <template v-else-if="item.key === 'device_type'">
            <span>{{ changeTextFn(cmdObj[item.key]) }}</span>
          </template>
          <template v-else-if="item.key === 'config_status'">
            <span>{{ textChange(cmdObj[item.key]) }}</span>
          </template>
          <template v-else-if="item.key === 'step'">
            <span>{{ stepFn(cmdObj[item.key]) }}</span>
          </template>
          <template v-else-if="item.isBool">
            <span v-if="cmdObj['config_status'] !== 2">{{
              objFn1(cmdObj[item.key])
            }}</span>
            <span style="color:red">{{ objFn2(cmdObj[item.key]) }}</span>
          </template>
          <span v-else>
            {{ cmdObj[item.key] }}
          </span>
        </span>
      </li>
    </ul>
    <el-form v-else label-position="right" label-width="150px" label-suffix="：">
      <el-form-item :label="$t('public.belong')">{{ url }}</el-form-item>
      <el-form-item :label="$t('integration.sensor_number')">
        <i v-icon="['equiStatusConvert', detail.status]"></i>
        {{ detail.tagId }}
      </el-form-item>
      <el-form-item :label="$t('public.config_status')">
        {{ $t(configStatusConvert(logData.status).title) }}
      </el-form-item>
      <el-form-item :label="$t('public.type')">
        {{ detail.type && $t(sensorTypeConvert(detail.type).title) }}
      </el-form-item>
      <!--      上报规则-->
      <template v-if="logData.type === 'app'">
        <!--二代温度计-->
        <template v-if="detail.type >= 7 && detail.type <= 8">
          <GenTwoTempConfig
            ref="genTwoConfig"
            :is-click-config="true"
          ></GenTwoTempConfig>
        </template>

        <!-- 4G温度计-->
        <template v-if="detail.type >= 9 && detail.type <= 12">
          <FourGTempConfig
            ref="fourGConfig"
            :is-click-config="true"
          ></FourGTempConfig>
        </template>
      </template>
      <!--      监测区间-->
      <template v-else-if="logData.type === 'range'">
        <el-form-item :label="$t('integration.minimum_temperature')">
          <Modify :item="JsonContent.content.item.min_temp"></Modify>
        </el-form-item>
        <el-form-item :label="$t('integration.maximum_temperature')">
          <Modify :item="JsonContent.content.item.max_temp"></Modify>
        </el-form-item>

        <el-form-item
          :label="$t('integration.minimum_humidity')"
          v-if="!isEmpty(JsonContent.content.item.min_hum)"
        >
          <Modify :item="JsonContent.content.item.min_hum"></Modify>
        </el-form-item>

        <el-form-item
          :label="$t('integration.maximum_humidity')"
          v-if="!isEmpty(JsonContent.content.item.max_hum)"
        >
          <Modify :item="JsonContent.content.item.max_hum"></Modify>
        </el-form-item>
      </template>
      <!--      报警-->
      <template v-else-if="logData.type === 'alarm'">
        <!-- 二代温度计 4G温度计声光报警-->
        <template v-if="detail.type >= 9 && detail.type <= 12">
          <SoundLightAlarm ref="soundLightAlarmRef"></SoundLightAlarm>
        </template>
      </template>
      <!--      GPS定位-->
      <template v-else-if="logData.type === 'gps'">
        <!--        4g温度计带GPS才有-->
        <template v-if="detail.type >= 11 && detail.type <= 12">
          <GPSLocate ref="gpsLocateRef"></GPSLocate>
        </template>
      </template>
      <el-form-item :label="$t('public.table_desc')">{{ detail.description }}</el-form-item>
      <el-form-item :label="$t('integration.configuration_steps')"
        >{{ stepFn(JsonContent.stepCode) }}
      </el-form-item>
    </el-form>
  </modal>
</template>

<script>
import { configStatusConvert, configStep } from '@/utils/convert'
import GenTwoTempConfig from '@/pages/equipment/sensor/components/sensor/cionfig/children/device/GenTwoTempConfig/GenTwoTempConfig.vue'
import FourGTempConfig from '@/pages/equipment/sensor/components/sensor/cionfig/children/device/FourGTempConfig/FourGTempConfig.vue'
import { getConfigContent, getConfigLogContent } from '@/api/modules/deviceUrl'
import { isEmpty } from '@/utils/common'
import Modify from '@/pages/equipment/base/components/configInfo/Modify.vue'
import { sensorType, sensorTypeConvert } from '@/utils/dict/sensor'
import SoundLightAlarm from '@/pages/equipment/sensor/components/sensor/cionfig/4GTempTab/SoundLightAlarm.vue'
import GPSLocate from '@/pages/equipment/sensor/components/sensor/cionfig/4GTempTab/GPSLocate.vue'

/**
 * 随着设备越来越多 且设备配置判断条件愈加复杂 目前此组件已不能满足新设备的使用需求
 * 故做出以下调整:
 * 1.type>=7以后的配置单独封装为一个组件放在./device目录下
 * 2.为保证旧设备逻辑正确, 不对旧设备的配置代码做大幅改动
 * 3.本组件兼容旧设备和新设备的两种传入方法
 *    - 旧设备传入cmdObj是格式化好的数据  该组件再根据baseMsg去匹配cmdObj内的内容
 *    - 新设备则可以通过[调用本组件的open函数]传入基础信息data 和日志的行信息logData
 *      以后统一在此组件内进行配置日志的请求 后传递到子组件
 */
export default {
  name: 'CmdDialog',
  components: {
    GPSLocate,
    SoundLightAlarm,
    Modify,
    FourGTempConfig,
    GenTwoTempConfig
  },
  props: {
    title: {},
    isShow: {},
    cmdObj: {}
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    url () {
      let url = this.detail.scopeName
      if (this.detail.sceneName) {
        url += '/' + this.detail.sceneName
      }
      if (this.detail.carrierName) {
        url += '/' + this.detail.carrierName
      }
      return url
    }
  },
  watch: {
    cmdObj (newVal) {
      this.baseMsg = [
        {
          key: 'url',
          text: 'public.belong'
        },
        {
          key: 'device_name',
          text: 'device.sensor_code'
        },
        {
          key: 'config_status',
          text: 'device.config_status'
        },
        {
          key: 'carrierName',
          text: 'public.carrier'
        },
        {
          key: 'device_type',
          text: 'public.type'
        },
        {
          key: 'description',
          text: 'public.table_desc'
        }
      ]
      // 去除监测点
      if (
        this.$attrs.sensorWay === 'unknown' ||
        this.$attrs.sensorWay === 'unbind'
      ) {
        this.baseMsg.splice(3, 1)
      }
      if (newVal.config_status === '') {
        this.baseMsg = this.baseMsg.filter(item => item.key !== 'config_status')
      }
      const publicArray = [
        {
          key: 'cmd',
          text: 'public.command'
        },
        {
          key: 'step',
          text: 'integration.configuration_steps'
        }
      ]
      const tempObj = [
        {
          key: 'tempCollectInterval',
          text: 'integration.temperature_acquisition_interval',
          isBool: true
        },
        {
          key: 'tempChange',
          text: 'integration.temperature_change_threshold',
          isBool: true
        },
        {
          key: 'tempMaxReport',
          text: 'integration.maximum_temperature_reporting_interval',
          isBool: true
        },
        {
          key: 'tempMinReport',
          text: 'integration.minimum_temperature_reporting_interval',
          isBool: true
        }
      ]
      const humObj = [
        {
          key: 'humCollectInterval',
          text: 'integration.humidity_collection_interval',
          isBool: true
        },
        {
          key: 'humChange',
          text: 'integration.humidity_change_threshold',
          isBool: true
        },
        {
          key: 'humMaxReport',
          text: 'integration.maximum_humidity_reporting_interval',
          isBool: true
        },
        {
          key: 'humMinReport',
          text: 'integration.humidity_minimum_reporting_interval',
          isBool: true
        }
      ]
      if (newVal.type === 'app') {
        // 上报规则
        if (newVal.device_type === 1 || newVal.device_type === 2) {
          this.baseMsg.push(
            {
              key: 'collectInterval',
              text: 'device.sample_interval',
              isBool: true
            },
            {
              key: 'exCollectInterval',
              text: 'device.exception_sample_interval',
              isBool: true
            },
            ...publicArray
          )
        } else if (newVal.device_type === 3 || newVal.device_type === 5) {
          // 待完善
          this.baseMsg.push(...tempObj, ...publicArray)
        } else if (newVal.device_type === 4 || newVal.device_type === 6) {
          this.baseMsg.push(...tempObj, ...humObj, ...publicArray)
        }
      } else if (newVal.type === 'net') {
        // zigbee的
        const zbArray = [
          {
            key: 'extPanId',
            text: 'Ext Pan ID',
            isBool: true
          },
          {
            key: 'channelPage',
            text: 'Join Attemp',
            isBool: true
          },
          {
            key: 'transmitPower',
            text: 'device.transmit_power',
            isBool: true
          },
          {
            key: 'channelMask',
            text: 'device.channel_mask',
            isBool: true
          },
          {
            key: 'inNetInterval',
            text: 'device.in_net_interval',
            isBool: true
          }
        ]
        const loraArray = [
          {
            key: 'devEui',
            text: 'DevEUI',
            isBool: true
          },
          {
            key: 'appEui',
            text: 'AppEUI',
            isBool: true
          },
          {
            key: 'appKey',
            text: 'AppKey',
            isBool: true
          },
          {
            key: 'channelMask',
            text: 'device.channel_mask',
            isBool: true
          },
          {
            key: 'inNetInterval',
            text: 'device.in_net_interval',
            isBool: true
          }
        ]
        const zetaArray = [
          {
            key: 'inNetInterval',
            text: 'device.in_net_interval',
            isBool: true
          }
        ]
        if (newVal.device_type === 1 || newVal.device_type === 2) {
          this.baseMsg.push(...zbArray, ...publicArray)
        } else if (newVal.device_type === 3 || newVal.device_type === 4) {
          this.baseMsg.push(...loraArray, ...publicArray)
        } else {
          this.baseMsg.push(...zetaArray, ...publicArray)
        }
      } else {
        const rangeArea = [
          {
            key: 'min_temp',
            text: 'integration.minimum_temperature',
            isBool: true
          },
          {
            key: 'max_temp',
            text: 'integration.maximum_temperature',
            isBool: true
          }
        ]
        // 湿度
        if (
          newVal.device_type === 2 ||
          newVal.device_type === 4 ||
          newVal.device_type === 6
        ) {
          rangeArea.push(
            {
              key: 'min_hum',
              text: 'integration.minimum_humidity',
              isBool: true
            },
            {
              key: 'max_hum',
              text: 'integration.maximum_humidity',
              isBool: true
            }
          )
        }
        this.baseMsg.push(...rangeArea)
      }
    }
  },
  data () {
    return {
      baseMsg: [],
      detail: {},
      logData: {},
      JsonContent: {}
    }
  },
  methods: {
    isEmpty,
    sensorTypeConvert,
    configStatusConvert,
    /**
     * 给外部调用  兼容两种调用方法   传感器类型太多了直接重构怕出问题
     * 也方便后续传感器类型扩充  不同的传感器使用不同的组件
     * 此方法会打开本对话框
     * @param data 传感器的行数据
     * @param logData 日志的行数据
     */
    open (data, logData) {
      this.detail = data
      this.logData = logData

      this.isShowDialog = true

      let param = ''
      let httpUrl = ''
      if (logData.responseDeviceConfigLogList) {
        param = 'configId'
        httpUrl = getConfigContent
      } else {
        param = 'configLogId'
        httpUrl = getConfigLogContent
      }

      httpUrl({ [param]: logData.id }, 'sensor').then(({ result }) => {
        if (result.content) {
          this.JsonContent = JSON.parse(result.content)
          console.log(this.JsonContent)
          this.JsonContent.content = JSON.parse(this.JsonContent.content)
          this.$set(this.JsonContent, 'stepCode', result.stepCode)
        } else if (result.deviceConfig) {
          this.JsonContent = {
            content: JSON.parse(result.deviceConfig.content),
            stepCode: result.stepCode
          }
        }
        // 如果是上报规则则显示上报规则对话框
        if (logData.type === 'app') {
          switch (data.type) {
            case 7:
            case 8:
              // 二代温度计
              this.$refs.genTwoConfig.setData(this.JsonContent.content)
              break

            case 9:
            case 10:
            case 11:
            case 12:
              // 4G 温度计
              this.$refs.fourGConfig.setData(this.JsonContent.content)
              break
          }
        } else if (logData.type === 'alarm') {
          // 判断二代温度计和4G温度计
          // 二代温度计和4G温度计都有声光报警
          switch (data.type) {
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
              // 4G 温度计
              this.$refs.soundLightAlarmRef.setData(
                this.JsonContent.content.item
              )
              break
          }
        } else if (logData.type === 'gps') {
          switch (data.type) {
            // 4g温度计带gps
            case 11:
            case 12:
              this.$refs.gpsLocateRef.setData(this.JsonContent.content.item)
              break
          }
        }
      })
    },
    textChange (key) {
      return this.$t(configStatusConvert(key).title)
    },

    changeTextFn (value) {
      return sensorType[value] && this.$t(sensorType[value].title)
    },
    objFn1 (obj) {
      if (!obj) return ''
      return obj.current + '-->'
    },
    objFn2 (obj) {
      if (!obj) return ''
      return obj.modify
    },
    stepFn (value) {
      return configStep[value] && this.$t(configStep[value].title)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-info {
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 10px;
  padding: 10px 20px;
  max-height: 500px;
  overflow: auto;

  li {
    display: contents;
  }

  .label {
    text-align: right;
    line-height: 32px;
    color: #606266;
    font-size: 14px;
  }

  .value {
    line-height: 32px;
    color: #606266;
    font-size: 14px;
    text-align: left;
  }
}
</style>
